import { API_URL } from "env";

// ==========================================
// 1. DEFINITIONS (Type & Interface)
// ==========================================

export interface ProductCategory {
    id: number;
    name: string;
    slug?: string;
}

export interface PromotionInfo {
    id: number;
    name: string;
    slug: string;
    start_date: string;
    end_date: string;
    is_active: number;
}

export interface PromotionProduct {
    product_id: number;
    promotion_id: number;
    percent: number;
    promotion?: PromotionInfo | null;
}

export interface PromotionFlashSaleProduct {
    product_id: number;
    promotion_flash_sale_id: number;
    percent: number;
    promotion_flash_sale?: {
        name: string;
        start_time?: string;
        end_time?: string;
    } | null;
}

// Cập nhật ProductItem: Chứa tất cả thông tin phẳng của sản phẩm
export interface ProductItem {
    id: number;
    name: string;
    slug: string;
    avatar: string;
    price: number;
    discount?: number;
    is_stock: number;

    // Các thông tin bổ sung
    content?: string;
    short_content?: string;
    ingredients?: string;
    indications?: string;
    contraindications?: string;
    dosage?: string;
    drug_interactions?: string;
    storage?: string;
    overdose?: string;

    product_category?: ProductCategory;
    promotion_product?: PromotionProduct[];
    promotion_flash_sale_product?: PromotionFlashSaleProduct[];

    // Trường optional dùng cho Frontend (số lượng trong giỏ/input)
    quantity?: number;
}

export interface CartResponseData {
    total: number;
    current_page: number;
    items: ProductItem[];
}

export interface CartResponse {
    status: boolean;
    data: CartResponseData;
    msg: string;
}

export interface CartFetchParams {
    page?: number;
    limit?: number;
    sort?: string[];
}

// ==========================================
// 2. API CALL FUNCTIONS
// ==========================================

async function fetchCartProducts(params?: CartFetchParams): Promise<CartResponseData | null> {
    const query = new URLSearchParams();
    query.append('sort[]', 'created_at,desc');

    if (params) {
        if (params.page) query.append('page', String(params.page));
        if (params.limit) query.append('limit', String(params.limit));
    }

    const baseUrl = `${API_URL.replace(/\/$/, '')}/api/v1/fe/products`;
    const url = `${baseUrl}?${query.toString()}`;

    // Lưu ý: Nên xử lý token động thay vì hardcode chuỗi dài này
    const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MjAwLCJ0aW1lIjoxNzcwMjIyMDA0LCJpcCI6IjQyLjExOS44NS4yMTQifQ.NwKSwck9ZAruaqOVWfYiiex52DgFXTDcLTV6qvy80JQ";

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        if (!response.ok) {
            console.error(`Error fetching cart: ${response.status} ${response.statusText}`);
            return null;
        }

        const jsonData = await response.json();
        console.log(jsonData);
        if (jsonData.data && jsonData.data.items) {
            return jsonData.data;
            console.log(jsonData.data);
        }

        return jsonData;

    } catch (error) {
        console.error("Failed to fetch cart products:", error);
        return null;
    }
}

export {
    fetchCartProducts,
};